import { render, staticRenderFns } from "./PricingDesktop.vue?vue&type=template&id=827ce14a&"
import script from "./PricingDesktop.vue?vue&type=script&lang=js&"
export * from "./PricingDesktop.vue?vue&type=script&lang=js&"
import style0 from "./PricingDesktop.vue?vue&type=style&index=0&id=827ce14a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports